import axios from "axios";
import React, { useState } from "react";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { ApiConnectionString } from "../../../constants/ApiConntection";

export default function ManageSubscriptionModal({
  cancelModal,
  selectedSub,
  fetchData,
  selectedStripeSub
}) {
  //styled
  const [cancelSub, setCancelSub] = useState(false);
  const [cancelComplete, setCancelComplete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuthContext();
  const handleCancelSub = async () => {
    setIsLoading(true);
    try {
      const cancelResponse = await axios.delete(
        `${ApiConnectionString}/api/subscription/${selectedSub.id}`,
        {
          headers: { Authorization: `bearer ${user.token}` },
        }
      );

      if (cancelResponse.status == 200) {
        
        setCancelComplete(true);
      }
    } catch (error) {
      console.error("Error canceling subscription:", error);
    } finally {
      setIsLoading(false); // Stop loading whether it succeeds or fails
    }
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
        </div>
      </div>
    );
  } else {
    if (cancelComplete) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">
                Subscription Canceled
              </p>
            </div>

            <button
              type="button"
              className="close-button"
              onClick={() => {fetchData();cancelModal()}}
              aria-label="Close"
            >
              &times;
            </button>

            <p>
              Their membership will end on{" "}
              {new Date(selectedStripeSub.nextPayDate).toLocaleDateString()}
              .
            </p>

            <div className="send-modal-footer">
              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      {
        return (
          <div className="send-modal-overlay">
            <div className="send-modal">
              <div className="blueBanner">
                <p className="fw-bold m-2 p-2 fontSize20">
                  Cancel Subscription
                </p>
              </div>

              <button
                type="button"
                className="close-button"
                onClick={cancelModal}
                aria-label="Close"
              >
                &times;
              </button>
              {/* <table>
                <tbody>
                  <tr>
                    <td className="red-text fw-bold">
                      <label>Customer:</label>
                    </td>
                    <td>
                      <p>{selectedSub.appUser.username}</p>
                    </td>
                  </tr>
                  <tr>
                    <td className="red-text fw-bold">
                      <label>Profile:</label>
                    </td>
                    <td>
                      <p>
                        {selectedSub.viewBookingProfile.firstName}{" "}
                        {selectedSub.viewBookingProfile.lastName} (
                        {selectedSub.viewBookingProfile.username})
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label className="red-text fw-bold">Subscription:</label>
                    </td>
                    <td>
                      <p>{selectedSub.product.name}</p>
                    </td>
                  </tr>
                </tbody>
              </table> */}

              <p>Are you sure you want to cancel this subscription?</p>

              <div className="send-modal-footer">
                <button className="delete-button" onClick={handleCancelSub}>
                  Confirm
                </button>

                <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        );
      }
    }
  }
}
